import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { cn } from '@bem-react/classname'
import parse from 'html-react-parser'

import { VerifyCode } from '@/components/Form/VerifyCode'
import { Tag } from '@/components/UI/Tag'

import './CodeStep.scss'

interface ICodeStepProps {
  className?: string
  onCompleted?: () => void
  value?: string
  type?: 'email' | 'phone' | '2fa' | 'code'
  title: string
  text?: string
}

const cnCodeStep = cn('CodeStep')

export const CodeStep: FC<ICodeStepProps> = ({
  className,
  onCompleted,
  value,
  type = 'email',
  text,
  title,
}) => {
  const { t } = useTranslation()

  const {
    control,
    formState: { errors },
  } = useFormContext<{ code: string }>()

  const onHandleChange = (value: string) => {
    if (value.length === 6 && onCompleted) onCompleted()
  }

  return (
    <div className={cnCodeStep(null, [className])}>
      <Tag className={cnCodeStep('title')}>{t(title)}</Tag>

      {value && text && type !== '2fa' ? (
        <div className={cnCodeStep('text')}>
          {parse(
            t(text, {
              ...(type === 'phone' ? { phone: `+${value}` } : { email: value }),
            }),
          )}
        </div>
      ) : (
        <>
          {text && <div className={cnCodeStep('text')}>{parse(t(text))}</div>}
        </>
      )}

      <Controller
        name='code'
        control={control}
        render={({ field: { onChange } }) => (
          <VerifyCode
            placeholder=''
            onChange={value => {
              onChange(value)
              onHandleChange(value)
            }}
            errors={t(errors.code?.message ?? '')}
            autoFocus
          />
        )}
      />
    </div>
  )
}
